import React from 'react';
import TeamItem from './TeamItem';
import { useSelector } from "react-redux";

export default function TeamBlock() {
      const leagueState = useSelector((state) => state.leagueReducer.data);
      const teamsState = useSelector((state) => state.teamsReducer.data);

	return (
            <div className='teams-block'>
                  {
                        // TeamBlock is not approved, as not yet known what functionality it should have
                  
                  /* {teamsState.map((team) => (
                        <TeamItem key={team.id} teamName={team.name} />
                  ))} */}
            </div>
		);
}